import * as types from '../actions/actionTypes'


const regionsReducer = (state = {
    allRegions: [],
}, action) => {

    switch(action.type) {
      case types.GET_ALL_REGIONS_SUCCESS: 
      
      let tempRegions = []
      for (var regionKey in action.payload) {
        tempRegions.push(action.payload[regionKey])
       }

       tempRegions.sort(function(a,b) {return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);} );

      state = {
        ...state,
        allRegions: tempRegions,
      };
      break;
      case types.DELETE_REGION_SUCCESS:
        const allRegionsForDelete = state.allRegions
        
        const result = allRegionsForDelete.filter(region => region.nodeName != action.payload);
        state = {
          ...state,
          allRegions: result,
        };
      break;
      case types.SET_CURRENT_COMPANY: 
        //if logging in with a different company wipe all of the store 
      state = {
        ...state,
        allRegions: action.payloadTwo ? state.allRegions : []
      };
      break;
      default:
      break;    
    }

    return state;
};


export default regionsReducer;


// WEBPACK FOOTER //
// ./src/reducers/regionsReducer.js